<div class="armado">
  <p class="ayuda">
    Arrastrá los botones entre las listas. El orden dentro de cada lista es la prioridad.
  </p>
  <div class="listas">
    <div class="lista">
      <h4>Principales</h4>
      <div
        cdkDropList
        #listaPrincipales="cdkDropList"
        [cdkDropListData]="idsPrincipales"
        [cdkDropListConnectedTo]="[listaSecundarios, listaOtros]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsPrincipales; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">Soltá botones acá</div>
        }
      </div>
    </div>

    <div class="lista">
      <h4>Secundarios</h4>
      <div
        cdkDropList
        #listaSecundarios="cdkDropList"
        [cdkDropListData]="idsSecundarios"
        [cdkDropListConnectedTo]="[listaPrincipales, listaOtros]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsSecundarios; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">Soltá botones acá</div>
        }
      </div>
    </div>

    <div class="lista">
      <h4>Otros</h4>
      <div
        cdkDropList
        #listaOtros="cdkDropList"
        [cdkDropListData]="idsOtros"
        [cdkDropListConnectedTo]="[listaPrincipales, listaSecundarios]"
        (cdkDropListDropped)="drop($event)"
        class="dropzone"
      >
        @for (id of idsOtros; track id) {
          <div class="chip" cdkDrag>
            <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            {{ btnLabel(id) }}
          </div>
        } @empty {
          <div class="vacio">Soltá botones acá</div>
        }
      </div>
    </div>
  </div>
</div>
